"use client";

import { ApplicationShellProvider as LayerApplicationShellProvider } from "@layer/ui/patterns";
import { SettingsDropdown } from "@/components/settings-dropdown";
import { UserDropdown } from "@/components/user-dropdown";
import { routes } from "@/lib/constants/routes";
import { CommandBar } from "@/modules/command-bar";

export const ApplicationShellProvider = ({
	children,
	userAgent,
}: {
	children: React.ReactNode;
	userAgent: string | null;
}) => {
	const baseRoutes = [...routes];

	const allAccessRoutes = baseRoutes.filter(
		(route) => route.auth === undefined,
	);

	const providerRoutes = [...allAccessRoutes];

	return (
		<LayerApplicationShellProvider
			tabKey="clientTabs"
			routes={providerRoutes}
			alwaysCollapsed
			isMinimalShell
			components={[
				<CommandBar key="command-bar" userAgent={userAgent || ""} />,
				<SettingsDropdown key="settings-dropdown" />,
				<UserDropdown key="user-dropdown" />,
			]}
		>
			{children}
		</LayerApplicationShellProvider>
	);
};
